import { Controller } from "@hotwired/stimulus"

// Makes a whole table row open a page, while links and buttons inside it keep
// working as normal.
// Connects to data-controller="row-link"
export default class extends Controller {
  static values = { url: String }

  visit(event) {
    if (event.target.closest("a, button, input, select, form")) return

    window.Turbo.visit(this.urlValue)
  }
}
